<template>
  <div style="display: flex;" :style="{width: width + 'px', minWidth: width + 'px', height: width + 'px', maxHeight: width + 'px'}">
    <img :class="variant" :src="currentSrc" @error="advance"/>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { ACTOR_LOGO_FALLBACK, actorLogo, getLogoDevLogoUrl } from '@/util/actor'

  export default defineComponent({
    name: 'ActorAvatar',
    props: {
      actor: {
        type: Object,
        required: true,
      },
      actorLogoUrl: {
        type: String,
        required: false,
      },
      variant: {},
      width: {
        type: Number,
        default: 100,
      },
      /** 'logo' (default) or 'screenshot' — determines which source is tried first */
      prefer: {
        type: String,
        default: 'logo',
      },
    },
    data() {
      return {
        stage: 0,
      }
    },
    watch: {
      actor() {
        this.stage = 0
      },
    },
    computed: {
      ACTOR_LOGO_FALLBACK () {
        return ACTOR_LOGO_FALLBACK
      },
      sources(): string[] {
        const srcs: string[] = []
        const logo = this.actor ? actorLogo(this.actor) : null
        const screenshot = this.actor?.website_screenshot || null
        const clearbit = getLogoDevLogoUrl(this.actorLogoUrl || this.actor?.url)

        if (this.prefer === 'screenshot') {
          if (screenshot) srcs.push(screenshot)
          if (logo) srcs.push(logo)
        } else {
          if (logo) srcs.push(logo)
          if (screenshot) srcs.push(screenshot)
        }

        if (clearbit) srcs.push(clearbit)
        srcs.push(ACTOR_LOGO_FALLBACK)

        return srcs
      },
      currentSrc(): string {
        return this.sources[this.stage] ?? ACTOR_LOGO_FALLBACK
      },
    },
    methods: {
      advance() {
        if (this.stage < this.sources.length - 1) {
          this.stage++
        }
      },
    },
  })
</script>

<style scoped lang="scss">
  img {
    min-width: 100%;
  }

  .rounded {
    border-radius: 0.5rem;
  }
</style>
